import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state: {
    loading: false,
    saving: false,
    generating: false,
    pending: false,
    typeModule: '',
    modeInvite: false
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/actionState/index.js